export default __webpack_public_path__ + "static/media/default-monochrome-black.a8270104.svg";